import React from 'react';
import { t } from '../../../../i18n';

type StepVariant = 'loading' | 'unloading' | 'unloading-scan';

interface TmsWaypointStepIndicatorProps {
  currentStep: number;
  /** loading: 装车流程(3步)；unloading: 卸车流程(2步)；unloading-scan: 卸车扫描流程(2步) */
  variant?: StepVariant;
}

const LOADING_STEPS = [
  { number: 1, labelKey: 'pda.pages.sealed.step1' },
  { number: 2, labelKey: 'pda.pages.sealed.step2' },
  { number: 3, labelKey: 'pda.pages.sealed.step3' }
];

const UNLOADING_STEPS = [
  { number: 1, labelKeys: ['pda.pages.unloadingDetail.step1', 'pda.pages.shipOut.unloading'], fallbackText: '卸车' },
  { number: 2, labelKeys: ['pda.pages.unloadingDetail.step2'], fallbackText: '上传BOL' }
];

const UNLOADING_SCAN_STEPS = [
  { number: 1, labelKeys: ['pda.pages.unloading.step1'], fallbackText: '卸车扫描' },
  { number: 2, labelKeys: ['pda.pages.unloading.step2'], fallbackText: '卸车信息' }
];

/**
 * TMS途径点步骤节点展示组件（支持装车3步、卸车2步）
 * @param currentStep 当前进行到的步骤
 * @param variant loading-装车流程 | unloading-卸车流程
 */
export const TmsWaypointStepIndicator: React.FC<TmsWaypointStepIndicatorProps> = ({
  currentStep,
  variant = 'loading'
}) => {
  const stepConfig = variant === 'unloading-scan' ? UNLOADING_SCAN_STEPS : variant === 'unloading' ? UNLOADING_STEPS : LOADING_STEPS;
  const steps = stepConfig.map(s => {
    const label = 'labelKey' in s
      ? t(s.labelKey)
      : (s.labelKeys.map(k => t(k)).find(v => v) || s.fallbackText);
    return { number: s.number, label };
  });

  const renderStepNode = (stepNumber: number, label: string) => {
    const isActive = stepNumber === currentStep;
    
    return (
      <div key={stepNumber} className="flex flex-col items-center gap-1">
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center ${
            isActive ? '' : 'bg-white border-2'
          }`}
          style={isActive ? { backgroundColor: '#7c3aed' } : { borderColor: '#7c3aed' }}
        >
          <span
            className="text-sm font-semibold"
            style={isActive ? { color: '#ffffff' } : { color: '#7c3aed' }}
          >
            {stepNumber}
          </span>
        </div>
        <span className="text-xs text-black">{label}</span>
      </div>
    );
  };

  return (
    <div className="flex items-center justify-center gap-4 bg-white rounded-lg">
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          {renderStepNode(step.number, step.label)}
          {index < steps.length - 1 && (
            <div className="flex-1 h-0.5 bg-gray-300 self-start mt-5"></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
